exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-content-job {\n  display: none;\n}\n@media (min-width: 768px) {\n.md-content-job {\n    display: block;\n}\n}\n", ""]);

// exports
